import { render, staticRenderFns } from "./ListSiswa.vue?vue&type=template&id=52bf24f3"
import script from "./ListSiswa.vue?vue&type=script&lang=js"
export * from "./ListSiswa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports